import { defineComponent, ref, computed, onMounted, watch } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiValue",
  props: {
    value: { type: Number, required: true },
    displayValue: { type: String, required: false },
    unit: { type: String, required: false },
    changeOnPreviousValue: { type: Boolean, required: false, default: false },
    changeOnZero: { type: Boolean, required: false, default: false },
    showIcon: { type: Boolean, required: false, default: false },
    priceQuality: { type: null, required: false }
  },
  setup(__props) {
    const props = __props;
    const previousValueChangeCssClass = ref("");
    const hasDisplayValue = computed(() => {
      return props.displayValue !== void 0;
    });
    const getValueMovementDirection = (value, base = 0) => {
      if (value < base) {
        return "negative";
      } else if (value > base) {
        return "positive";
      }
      return "neutral";
    };
    const getIconClass = (value, base = 0) => {
      if (value < base) {
        return "trending-negative";
      } else if (value > base) {
        return "trending-positive";
      }
      return "neutral";
    };
    const updatePreviousValueCssClass = (newValue, oldValue) => {
      if (props.changeOnPreviousValue && oldValue !== void 0) {
        previousValueChangeCssClass.value = "";
        setTimeout(() => {
          previousValueChangeCssClass.value = `fds-value-previousValue--${getValueMovementDirection(newValue, oldValue)}`;
        }, 10);
      }
    };
    const zeroChangeCssClass = computed(() => {
      if (props.changeOnZero) {
        return `fds-value-zero--${getValueMovementDirection(props.value || Number.NaN)}`;
      }
      return "";
    });
    const iconClassModifier = computed(() => {
      return `fds-ui-icon--${getIconClass(props.value || Number.NaN)}`;
    });
    const priceQualitySymbol = computed(() => {
      switch (props.priceQuality) {
        case "RLT":
          return "R";
        case "DLY":
          return "D";
        case "EOD":
          return "E";
        default:
          return "";
      }
    });
    const shouldWatchForChanges = computed(() => {
      return props.changeOnPreviousValue || props.changeOnZero;
    });
    onMounted(() => {
      if (shouldWatchForChanges.value) {
        if (props.value) {
          updatePreviousValueCssClass(props.value);
        }
        watch(() => props.value, updatePreviousValueCssClass);
      }
    });
    return { __sfc: true, props, previousValueChangeCssClass, hasDisplayValue, getValueMovementDirection, getIconClass, updatePreviousValueCssClass, zeroChangeCssClass, iconClassModifier, priceQualitySymbol, shouldWatchForChanges };
  }
});

export { _sfc_main as default };
